import {useEffect, useState} from "react";
import {GET} from "../../APIclient";
import {useNavigate} from "react-router-dom";
import {logoutFromAllTabs} from "../../utils/authSync";
 
function Logout() {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState("");
  const url = `api/logout`;
  const navigate = useNavigate();


  const keysToRemove = [
    "login_response",
    "login_response_auth",
    "jwtToken",
    "refreshToken",
    "expirationTime",
    "EmpName",
    "currentDesignation",
    "photoBase64", 
    "username",   
    "calendarEvents",
    "conferenceBookings",
    "calendarEventData",
    "conferenceBookingsData",
    "Employee_Details"
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        keysToRemove.forEach(key => localStorage.removeItem(key));
        sessionStorage.clear();

        const response = await GET(url);
        console.log("response", response);
        const data = response.data;
        if (data.statusCode === 200) {
          setUserData(data);
        }
      } catch (error) {
        console.error("Error during logout:", error);
      } finally {
        logoutFromAllTabs();
        setIsLoading(false);
      }
    };
    fetchData();
  }, [navigate]);

  if (isLoading) {
    return null;
  }
 
  // return <div>{userData.message}</div>;
}

export default Logout;
